document.addEventListener("DOMContentLoaded", function () {
  let isMobileView = window.innerWidth <= 768; 

  function updateTexts() {
    const paragraphs = document.querySelectorAll('.progress-hd .btmTxt p');
    paragraphs.forEach(p => {
      let original = p.getAttribute('data-original');
      if (!original) {
      
        p.setAttribute('data-original', p.textContent);
        original = p.textContent;
      }

      
      if (isMobileView) {
        p.textContent = original.replace(/^\d{1,2}\.\s*/, '');
      } else {
        p.textContent = original; 
      }
    });
  }


  updateTexts();


  window.addEventListener('resize', function () {
    const nowMobile = window.innerWidth <= 768;
    if (nowMobile !== isMobileView) {
      isMobileView = nowMobile;
      updateTexts(); 
    }
  });
});